<template>
	<div>
		<div class="select-box">
			<div class="title-box">
				<el-input
					v-model="userName"
					placeholder="请输入门店名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="searchClick"
					>
				</el-input>
				<el-button style="margin-left: 10px;" @click='searchClick' size='mini' type="primary">查询</el-button>
			</div>
		</div>
		<div style="width: 100%; height: 400px;margin-top: 10px; display: flex;flex-direction: row;justify-content: space-between;">
			<div class="left-box">
				<div class="staff-name-box">
					请选择
				</div>
				<div class="tree-box">
					<div v-for="(item,index) in treeData" :key='index'>
						<div class="title-box" @click="showCusChange(index)">
							<div class="left">
								<!-- <el-checkbox :true-label='1' :false-label='0' v-model="item.checked" @change='cateChange(item,item.checked)'></el-checkbox> -->
								<img style="margin:0px 5px;" src="~/images/icon/customerCategory.png">
								<span style="color: #333333;">{{item.name}}</span>
							</div>
							<div class="right">
								<i v-if="item.showCus === 1" class="el-icon-arrow-up"></i>
								<i v-if="item.showCus === 0" class="el-icon-arrow-down"></i>
							</div>
						</div>
						<div class="content-box" v-show='item.showCus ===1' v-for='(item1,index1) in item.cus' :key='index1'>
							<el-checkbox :true-label='1' :false-label='0' v-model="item1.checked" @change='customerChange(item,item1,item1.checked)'>
								<span style="color: #595959;">{{item1.name}}</span>
							</el-checkbox>
						</div>
					</div>
				</div>
			</div>
			<div class="right-box">
				<div class="staff-name-box">
					已选择
				</div>
				<div v-for="(item,index) in chooseData" :key='index'>
					<div class="title-box" @click="chooseShowCusChange(item.categoryOrLevelFlag,index)">
						<div class="left" style="color: #333333;">
							<img style="margin:0px 5px;" src="~/images/icon/customerCategory.png">
							<span>{{item.name}}</span>
							<img v-if="item.categoryOrLevelFlag === 1" style="margin:0px 5px;" src="~/images/icon/allCategory.png">
							<span v-if="item.categoryOrLevelFlag === 1">整类</span>
						</div>
						<div class="right">
							<i @click="delCateClick(item,index)" v-if="item.categoryOrLevelFlag === 1" class="el-icon-close"></i>
							<i v-if="item.categoryOrLevelFlag !== 1 && item.showCus ===1" class="el-icon-arrow-up"></i>
							<i v-if="item.categoryOrLevelFlag !== 1 && item.showCus ===0" class="el-icon-arrow-down"></i>
						</div>
					</div>
					<div style="color: #595959;" class="content-box" v-show="item.categoryOrLevelFlag === 0 && item.showCus ===1 && item1.id !== '-1'" v-for="(item1,index1) in item.cus" :key='index1'>
						{{item1.name}}
						<i @click="delCusClick(item,item1,index,index1)" class="el-icon-close"></i>
					</div>
				</div>
			</div>
		</div>
		<div style="width: 100%;margin:10px 0px;text-align: left;color: #999999;">
			已选：
			<span style="color:#333;font-weight: Bold;">
				{{num}}
			</span>
			个
		</div>
		<div style="width: 100%;height: 50px;text-align: right;">
			<el-button @click='closeClick' size='mini'>取消</el-button>
			<el-button @click='saveClick' size='mini' type="primary">确定</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'bindCustomer',
	props: {
		customerDialog: Boolean,
		chooseData1: Array
	},
	data () {
		return {
			num: 0,
			show: true,
			userName: '',
			chooseData: [],
			treeData: []
		}
	},
	created () {
		this.dataByCate = this.chooseCusByCate
		this.dataByLevel = this.chooseCusBylevel
		// this.chooseData = this.chooseData1
		this.getTree()
	},
	methods: {
		checkNum () {
			let list = this.chooseData
			if (list.length === 0) {
				this.num = 0
			}
			let num = 0
			list.forEach(item => {
				item.cus.forEach(cusItem => {
					if (cusItem.id !== '-1') {
						num++
					}
				})
			})
			this.num = num
		},
		closeClick () {
			this.$emit('update:customerDialog', false)
		},
		sort (data) {
			let allCus = []
			let cus = []
			for (let i = 0; i < data.length; i++) {
				if (data[i].categoryOrLevelFlag === 1) {
					allCus.push(data[i])
				} else {
					cus.push(data[i])
				}
			}
			return allCus.concat(cus)
		},
		delCusClick (cate, cus, index, cusIndex) {
			this.chooseData[index].cus.splice(cusIndex, 1)
			this.chooseData[index].cus.forEach((item, index1) => {
				if (item.id === '-1') {
					this.chooseData[index].cus.splice(index1, 1)
				}
			})
			if (this.chooseData[index].cus.length === 0) {
				this.chooseData.splice(index, 1)
			}
			let list = this.treeData
			for (let i = 0; i < list.length; i++) {
				if (list[i].id === cate.id) {
					list[i].checked = 0
					for (let j = 0; j < list[i].cus.length; j++) {
						list[i].cus[0].checked = false
						if (list[i].cus[j].id === cus.id) {
							list[i].cus[j].checked = false
						}
					}
				}
			}
			this.chooseData = this.sort(this.chooseData)
			this.checkNum()
		},
		delCateClick (cate, index) {
			this.chooseData.splice(index, 1)
			let list = this.treeData
			for (let i = 0; i < list.length; i++) {
				if (list[i].id === cate.id) {
					list[i].checked = 0
					for (let j = 0; j < list[i].cus.length; j++) {
						list[i].cus[j].checked = 0
					}
				}
			}
			this.chooseData = this.sort(this.chooseData)
			this.checkNum()
		},
		initTreeData () {
			let chooseList = JSON.parse(JSON.stringify(this.chooseData))
			let treeList = JSON.parse(JSON.stringify(this.treeData))
			for (let i = 0; i < chooseList.length; i++) {
				for (let j = 0; j < treeList.length; j++) {
					if (chooseList[i].id === treeList[j].id) {
						if (chooseList[i].categoryOrLevelFlag === 1) {
							treeList[j].checked = 1
							for (let z = 0; z < treeList[j].cus.length; z++) {
								treeList[j].cus[z].checked = 1
							}
						} else {
							treeList[j].checked = 0
							for (let x = 0; x < chooseList[i].cus.length; x++) {
								for (let c = 0; c < treeList[j].cus.length; c++) {
									if (chooseList[i].cus[x].id === treeList[j].cus[c].id) {
										treeList[j].cus[c].checked = 1
									}
								}
							}
						}
					}
				}
			}
			this.treeData = treeList
			this.checkAllChoose(true)
		},
		showCusChange (index) {
			if (this.treeData[index].showCus === 1) {
				this.treeData[index].showCus = 0
			} else {
				this.treeData[index].showCus = 1
			}
		},
		chooseShowCusChange (flag, index) {
			if (flag === 1) {
				return false
			}
			if (this.chooseData[index].showCus === 1) {
				this.chooseData[index].showCus = 0
			} else {
				this.chooseData[index].showCus = 1
			}
		},
		checkAllChoose (isChoose) {
			let tree = JSON.parse(JSON.stringify(this.treeData))
			tree.forEach(treeItem => {
				// let num = 0
				treeItem.cus.forEach(item => {
					if (item.id === '-1') {
						item.checked = treeItem.count === this.checkchoose(treeItem.cus) ? 1 : 0
					}
				})
			})
			this.treeData = tree
			this.checkNum()
		},
		checkchoose (data) {
			let num = 0
			data.forEach(item => {
				if (item.checked === 1 && item.id !== '-1') {
					num++
				}
			})
			return num
		},
		allClick (cate, isChoose) {
			let i = null
			let chooseIndex = null
			this.treeData.forEach((item, index) => {
				if (item.id === cate.id) {
					i = index
				}
			})
			this.chooseData.forEach((item, index) => {
				if (item.id === cate.id) {
					chooseIndex = index
				}
			})
			this.treeData[i].cus.forEach(item => {
				item.checked = isChoose
			})
			if (isChoose === 1) {
				let cus = JSON.parse(JSON.stringify(this.treeData[i].cus))
				let row = {
					'name': cate.name,
					'id': cate.id,
					'showCus': 1,
					'categoryOrLevelFlag': 0,
					'cus': cus,
					'count': cate.count
				}
				if (chooseIndex === null) {
					this.chooseData.push(row)
				} else {
					this.chooseData.splice(chooseIndex, 1)
					this.chooseData.push(row)
				}
			} else {
				this.chooseData.splice(chooseIndex, 1)
			}
			this.chooseData = this.sort(this.chooseData)
			this.checkNum()
		},
		cateChange (cate, isChoose) {
			let i = null
			let chooseIndex = null
			this.treeData.forEach((item, index) => {
				if (item.id === cate.id) {
					i = index
				}
			})
			this.chooseData.forEach((item, index) => {
				if (item.id === cate.id) {
					chooseIndex = index
				}
			})
			this.treeData[i].cus.forEach(item => {
				item.checked = isChoose
			})
			if (isChoose === 1) {
				let cus = JSON.parse(JSON.stringify(this.treeData[i].cus))
				let row = {
					'name': cate.name,
					'id': cate.id,
					'showCus': 1,
					'categoryOrLevelFlag': 1,
					'cus': cus,
					'count': cate.count
				}
				if (chooseIndex === null) {
					this.chooseData.push(row)
				} else {
					this.chooseData.splice(chooseIndex, 1)
					this.chooseData.push(row)
				}
			} else {
				this.chooseData.splice(chooseIndex, 1)
			}
			this.chooseData = this.sort(this.chooseData)
			this.checkNum()
		},
		initShopData (type) {
			let textArr = []
			let idArr = []
			let list = this.chooseData
			list.forEach(item => {
				item.cus.forEach(shop => {
					if (shop.id !== '-1') {
						textArr.push(shop.name)
						idArr.push(shop.id)
					}
				})
			})
			if (type === 'name') {
				let text = textArr.join('，')
				return text
			}
			if (type === 'id') {
				return idArr
			}
		},
		saveClick () {
			if (this.chooseData.length === 0) {
				this.$message.error('至少选择一个门店')
				return false
			}
			let params = {
				chooseData: this.initShopData('id'),
				shopText: this.initShopData('name')
			}
			this.$emit('reloadCus', params)
		},
		searchClick () {
			let params = {
				name: this.userName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/getAreaAndShop`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data
					data.forEach(item => {
						item.cus = item.shop
						if (this.userName === '') {
							item.cus.unshift({
								name: '全部',
								id: '-1'
							})
						}
					})
					this.treeData = data
					this.initTreeData()
				}
			})
		},
		getTree (val) {
			let params = {
				name: this.userName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/getAreaAndShop`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data
					data.forEach(item => {
						item.cus = item.shop
						if (this.userName === '') {
							item.cus.unshift({
								name: '全部',
								id: '-1'
							})
						}
					})
					this.treeData = data
					this.initChooseData(this.chooseData1)
					this.chooseData = this.sort(this.chooseData)
					this.initTreeData()
				}
			})
		},
		initChooseData (data) {
			let chooseArr = []
			let treeArr = JSON.parse(JSON.stringify(this.treeData))
			const selectedSet = new Set((data || []).map(id => String(id)))
			treeArr.forEach(item => {
				let arr = []
				item.cus.forEach(shopItem => {
					if (selectedSet.has(String(shopItem.id))) {
						arr.push(shopItem)
					}
				})
				if (arr.length > 0) {
					let row = {
						categoryOrLevelFlag: 0,
						checked: item.checked,
						count: item.count,
						cus: arr,
						id: item.id,
						name: item.name,
						showCus: item.showCus
					}
					chooseArr.push(row)
				}
			})
			console.log(chooseArr)
			this.chooseData = chooseArr
		},
		customerChange (cate, cusrow, isChoose) {
			this.treeData.forEach(item => {
				if (item.id === cate.id) {
					item.checked = 0
				}
			})
			let list = JSON.parse(JSON.stringify(this.chooseData))
			let flag = false
			let cateIndex = null
			for (let i = 0; i < list.length; i++) {
				if (list[i].id === cate.id) {
					flag = true
					cateIndex = i
				}
			}
			if (cusrow.id === '-1') {
				this.allClick(cate, isChoose)
				return false
			}
			if (isChoose === 1) {
				if (flag) {
					list[cateIndex].categoryOrLevelFlag = 0
					list[cateIndex].cus.push(cusrow)
				} else {
					let row = {
						'name': cate.name,
						'id': cate.id,
						'categoryOrLevelFlag': 0,
						'showCus': 1,
						'cus': [cusrow],
						'count': cate.count
					}
					list.push(row)
				}
			} else {
				list[cateIndex].categoryOrLevelFlag = 0
				let cusList = list[cateIndex].cus
				let cusIndex = null
				cusList.forEach((item, index) => {
					if (item.id === '-1') {
						cusList.splice(index, 1)
					}
					if (cusrow.id === item.id) {
						cusIndex = index
					}
				})
				list[cateIndex].cus.splice(cusIndex, 1)
				if (list[cateIndex].cus.length === 0) {
					list.splice(cateIndex, 1)
				}
			}
			this.chooseData = this.sort(list)
			this.checkAllChoose(isChoose)
		}
	}
}
</script>

<style lang="stylus" scoped>
.staff-name-box{
	display:flex;
	align-items center;
	justify-content:center
	color :#999999;
	height :40px;
	position :relative
}
.staff-name-box::before{
	content:'';
	width:60px;
	border-bottom:1px solid #E3E3E3;
	position:absolute;
	left:20px;
	top:20px;
}
.staff-name-box::after{
	content:'';
	width:60px;
	border-bottom:1px solid #E3E3E3;
	position:absolute;
	right:20px;
	top:20px;
}
.el-icon-arrow-up{
	color:#AFB1B3 !important
}
.el-icon-arrow-down{
	color:#AFB1B3 !important
}
.select-box{
	display flex
	width: 100%;
	align-items: center;
	justify-content :space-between;
	height: 40px;
	.title-box{
		width :350px;
		display: flex;
		justify-content: flex-start;
	}
}
.left-box{
	padding: 10px;
	width: 350px;
	height: 100%;
	display :flex;
	flex-direction :column;
	box-sizing :border-box;
	background-color: #F9F9F9
	.tree-box{
		flex:1;
		padding: 5px;
		overflow-y: auto;
	}
}
.title-box{
	display:flex;
	flex-direction :row;
	justify-content:space-between;
	align-items :center;
	.left{
		display:flex;
		flex-direction :row;
		align-items :center;
		height :30px;
	}
}
.content-box{
	display:flex;
	flex-direction :row;
	align-items :center;
	height :30px;
	padding-left:30px;
	box-sizing :border-box;
}
.right-box{
	box-sizing:border-box;
	padding :10px;
	width: 350px;
	height: 100%;
	overflow-y:auto;
	background-color: #F9F9F9
	.content-box{
		justify-content :space-between
	}
}
</style>
